import { UPDATE_VERSION } from "../actions/version"

const version = (state, action) => {

    if (!state) {
        state = { version: "v0" };
    }

    switch (action.type) {
        case UPDATE_VERSION:
            return Object.assign({}, state, { version: action.version })
        default:
            return state;
    }
}

export default version;
